import { render, staticRenderFns } from "./hall-buy.vue?vue&type=template&id=568f2d07&scoped=true&"
import script from "./hall-buy.vue?vue&type=script&lang=js&"
export * from "./hall-buy.vue?vue&type=script&lang=js&"
import style0 from "./hall-buy.vue?vue&type=style&index=0&id=568f2d07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568f2d07",
  null
  
)

export default component.exports